import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Plugin Manager/Plugin";
import * as React from 'react';
export default {
  Content,
  React
};